import React, { Component } from "react";
import axios from "axios";
const config = require("../config.json");

export default class CampaignStats extends Component {
  state = {
    users: [],
    campaigns: [],
    campaignActivities: [],
    teams: [],
    companies: [],
    loading: false,
    totalCounts: {},
    campaignIdSelected: "",
    quizzes: [],
    campaignQuizzes: {},
    mode: "activity", // activity | quiz
  };

  fetchCampaignStats = async (id) => {
    let lastEvaluatedKey = "";
    let isDone = false;
    let users = [];

    this.setState({ users: [], campaignActivities: [] });

    while (!isDone) {
      try {
        const res = await axios.post(
          `${config.api.invokeUrl}/campaign/${id}/stats`,
          { lastEvaluatedKey }
        );

        if (res.data.lastEvaluatedKey) {
          lastEvaluatedKey = res.data.lastEvaluatedKey;
        } else {
          isDone = true;
        }
        users = [...this.state.users, ...res.data.users];
        const campaignActivities = [
          this.state.campaignActivities,
          ...res.data.campaignActivities,
        ];

        this.setState({ users, campaignActivities });
        this.getTotalCounts(users, campaignActivities);
      } catch (err) {
        isDone = true;
        console.log(err);
      }
    }

    this.getQuizStats(users, id);
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign`);
      const campaigns = res.data;
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCompanies = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/companies`);
      const companies = res.data;
      this.setState({ companies: companies });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaignTeams = async (campaignId) => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/campaign/${campaignId}/teams`
      );
      const teams = res.data;
      this.setState({ teams: teams });
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = () => {
    this.fetchAll();
  };

  getTotalCounts = (users, campaignActivities) => {
    let totalActivityCount = 0;
    let totalCounts = {};

    users.forEach((user) => {
      let userTotal = 0;
      campaignActivities.forEach((activity) => {
        let activityId = "";
        if (activity.choices?.length) {
          for (const choice of activity.choices) {
            activityId = activity.id + choice.text_da;
            if (!totalCounts[activityId]) {
              totalCounts[activityId] = user.stats.activities[activityId];
            } else {
              totalCounts[activityId] += user.stats.activities[activityId];
            }

            if (!isNaN(user.stats.activities[activityId])) {
              totalActivityCount += user.stats.activities[activityId];
              userTotal += user.stats.activities[activityId];
            }
          }
        } else {
          activityId = activity.id;
          if (!totalCounts[activityId]) {
            totalCounts[activityId] = user.stats.activities[activityId];
          } else {
            totalCounts[activityId] += user.stats.activities[activityId];
          }

          if (!isNaN(user.stats.activities[activityId])) {
            totalActivityCount += user.stats.activities[activityId];
            userTotal += user.stats.activities[activityId];
          }
        }
      });

      totalCounts[user.id] = userTotal;
    });

    this.setState({
      totalCounts: { ...totalCounts, totalActivityCount: totalActivityCount },
    });
  };

  getQuizStats = (users, campaignIdSelected) => {
    const campaignQuizzes = {};
    const campaign = this.state.campaigns.find(
      (campaign) => campaign.id == campaignIdSelected
    );

    for (const user of users) {
      for (let week = 1; week <= campaign.currentWeek; week++) {
        if (user.doneActivities[week]) {
          for (const activityId of Object.keys(user.doneActivities[week])) {
            const doneActivity = user.doneActivities[week][activityId];
            if (doneActivity.category == "Quiz") {
              if (!campaignQuizzes[activityId]) {
                campaignQuizzes[activityId] = {
                  choices: {},
                  dates: {},
                };
              }

              // choices are stored with date keys: { [dateString]: choice }
              for (const [dateKey, choice] of Object.entries(
                doneActivity.choices || {}
              )) {
                if (!campaignQuizzes[activityId].choices[choice.text_da]) {
                  campaignQuizzes[activityId].choices[choice.text_da] = 0;
                }
                campaignQuizzes[activityId].choices[choice.text_da] += 1;

                if (!campaignQuizzes[activityId].dates[dateKey]) {
                  campaignQuizzes[activityId].dates[dateKey] = 0;
                }
                campaignQuizzes[activityId].dates[dateKey] += 1;
              }
            }
          }
        }
      }
    }
    console.log(campaignQuizzes);
    this.setState({ campaignQuizzes: campaignQuizzes });
  };

  renderQuizStats = () => {
    const { campaignQuizzes = {}, quizzes = [] } = this.state;
    const quizIds = Object.keys(campaignQuizzes || {});

    if (!quizIds.length) {
      return (
        <div style={{ marginTop: "1rem" }}>Ingen quiz-besvarelser endnu.</div>
      );
    }

    // Sort quizzes by most recent answer date
    const sortedQuizIds = quizIds.sort((idA, idB) => {
      const datesA = Object.keys(campaignQuizzes[idA]?.dates || {});
      const datesB = Object.keys(campaignQuizzes[idB]?.dates || {});

      if (!datesA.length) return 1;
      if (!datesB.length) return -1;

      // Convert date strings to Date objects and find the most recent
      const maxDateA = datesA.map((d) => new Date(d)).sort((a, b) => b - a)[0]; // Most recent date for quiz A
      const maxDateB = datesB.map((d) => new Date(d)).sort((a, b) => b - a)[0]; // Most recent date for quiz B

      return maxDateB - maxDateA; // Sort descending (most recent first)
    });

    return (
      <div className="columns is-multiline">
        {sortedQuizIds.map((quizId) => {
          const statsForQuiz = campaignQuizzes[quizId];
          const quiz = quizzes.find((q) => q.id == quizId);
          const totalResponses = Object.values(
            statsForQuiz.choices || {}
          ).reduce((sum, n) => sum + (isNaN(n) ? 0 : n), 0);

          if (!quiz) {
            return null;
          }

          const answersSorted = (quiz.answers || [])
            .map((ans, idx) => {
              const count = statsForQuiz.choices?.[ans.text_da] || 0;
              return { ans, idx, count };
            })
            .sort((a, b) => b.count - a.count);

          return (
            <div className="column is-full" key={quizId}>
              <h3 className="subtitle is-5" style={{ marginTop: "1rem" }}>
                {quiz.quizName || quiz.question_da}
              </h3>
              <table className="stats-table">
                <thead>
                  <tr>
                    <th align="left">Svar</th>
                    <th align="center">Procent</th>
                    <th align="center">Antal</th>
                    <th align="center">Korrekt?</th>
                  </tr>
                </thead>
                <tbody>
                  {answersSorted.map(({ ans, idx, count }) => {
                    const pct = totalResponses
                      ? ((count / totalResponses) * 100).toFixed(1)
                      : "0.0";
                    return (
                      <tr key={quizId + "_" + (ans.text_da || idx)}>
                        <td>{ans.text_da}</td>
                        <td align="center">{pct}%</td>
                        <td align="center">{count}</td>
                        <td align="center">{ans.correct ? "✓" : ""}</td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td>
                      <strong>I alt</strong>
                    </td>
                    <td></td>
                    <td align="center">
                      <strong>{totalResponses}</strong>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              {(() => {
                const dateEntries = Object.entries(statsForQuiz.dates || {});
                if (!dateEntries.length) return null;
                const total = dateEntries.reduce(
                  (s, [, n]) => s + (isNaN(n) ? 0 : n),
                  0
                );
                return (
                  <div style={{ marginTop: "0.75rem" }}>
                    <h4 className="subtitle is-6">Datoer besvaret</h4>
                    <table className="stats-table">
                      <thead>
                        <tr>
                          <th align="left">Dato</th>
                          <th align="center">Antal</th>
                          <th align="center">Procent</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dateEntries
                          .sort(([, countA], [, countB]) => countB - countA)
                          .map(([dateKey, count]) => {
                            const pct = total
                              ? ((count / total) * 100).toFixed(1)
                              : "0.0";
                            return (
                              <tr key={quizId + "_date_" + dateKey}>
                                <td>{dateKey}</td>
                                <td align="center">{count}</td>
                                <td align="center">{pct}%</td>
                              </tr>
                            );
                          })}
                        <tr>
                          <td>
                            <strong>I alt</strong>
                          </td>
                          <td align="center">
                            <strong>{total}</strong>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                );
              })()}
            </div>
          );
        })}
      </div>
    );
  };

  fetchQuizzes = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/quiz`);
      const quizzes = res.data;

      this.setState({ quizzes: quizzes });
    } catch (err) {
      console.log(err);
    }
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    let promise = await Promise.all([
      this.fetchCompanies(),
      this.fetchCampaigns(),
      this.fetchQuizzes(),
    ]);
    const campaignSelected = document.getElementById("campaigns")?.value;
    await Promise.all([
      this.fetchCampaignTeams(campaignSelected),
      this.fetchCampaignStats(campaignSelected),
    ]);

    this.setState({ loading: false });
  };

  createCSV = (users, campaignActivities) => {
    const csvRows = [];

    let headers = ["ID", "Navn", "Hold", "Organisation"];
    headers = headers.concat(
      campaignActivities.map((activity) => {
        if (activity.choices?.length) {
          return activity.choices.map(
            (cho) => `"${activity.activityName} - ${cho.text_da}"`
          );
        } else {
          return `"${activity.activityName}"`;
        }
      })
    );
    csvRows.push(headers.join(","));

    users.forEach((user) => {
      let values = [
        user.id,
        `"${user.userName}"`,
        `"${
          user.team
            ? this.state.teams.find((team) => team.id == user.team)?.teamName
            : "N/A"
        }"`,
        `"${
          user.company
            ? this.state.companies.find((company) => company.id == user.company)
                .companyName
            : "N/A"
        }"`,
      ];

      values = values.concat(
        this.state.campaignActivities.map((activity) => {
          if (activity.choices?.length) {
            return activity.choices.map(
              (cho) => `"${user.stats.activities[activity.id + cho.text_da]}"`
            );
          } else {
            return `"${user.stats.activities[activity.id]}"`;
          }
        })
      );
      csvRows.push(values);
    });

    return csvRows.join("\n");
  };

  downloadCSV = (data, campaignId) => {
    // Creating a Blob for having a csv file format
    // and passing the data with type
    const blob = new Blob([data], { type: "text/csv" });

    // Creating an object for downloading url
    const url = window.URL.createObjectURL(blob);

    // Creating an anchor(a) tag of HTML
    const a = document.createElement("a");

    // Passing the blob downloading url
    a.setAttribute("href", url);

    // Setting the anchor tag attribute for downloading
    // and passing the download file name
    a.setAttribute(
      "download",
      this.state.campaigns.find((campaign) => campaign.id == campaignId)
        ?.campaignName + "_stats.csv"
    );

    // Performing a download with click
    a.click();
  };

  render() {
    return (
      <>
        <section className="section">
          <div className=" p-small">
            <h1>Kampagne statistik</h1>
            <br />
            <div className="control">
              <select
                className="select is-medium"
                name="campaigns"
                id="campaigns"
                onChange={async () => {
                  this.setState({ loading: true });
                  const select = document.getElementById("campaigns");
                  await this.fetchCampaignTeams(
                    select.options[select.selectedIndex].value
                  );
                  await this.fetchCampaignStats(
                    select.options[select.selectedIndex].value
                  );

                  this.setState({
                    loading: false,
                    campaignIdSelected:
                      select.options[select.selectedIndex].value,
                  });
                }}
              >
                {this.state.campaigns.map((campaign) => {
                  return (
                    <option key={campaign.id} value={campaign.id}>
                      {campaign.campaignName}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="control" style={{ marginTop: "0.5rem" }}>
              <div className="buttons has-addons">
                <button
                  className={
                    "button is-medium " +
                    (this.state.mode === "activity"
                      ? "is-primary is-selected"
                      : "")
                  }
                  onClick={() => this.setState({ mode: "activity" })}
                >
                  Aktivitet Stats
                </button>
                <button
                  className={
                    "button is-medium " +
                    (this.state.mode === "quiz" ? "is-primary is-selected" : "")
                  }
                  onClick={() => this.setState({ mode: "quiz" })}
                >
                  Quiz Stats
                </button>
              </div>
            </div>

            <div className="control">
              <button
                onClick={() => {
                  this.downloadCSV(
                    this.createCSV(
                      this.state.users,
                      this.state.campaignActivities
                    ),
                    document.getElementById("campaigns")?.value
                  );
                }}
              >
                Eksporter som CSV
              </button>
            </div>
            <div className="columns is-multiline">
              <div className="column"></div>
            </div>
            {!this.state.loading && this.state.mode !== "quiz" && (
              <table className="stats-table">
                <thead>
                  <tr>
                    <th align="center">ID</th>
                    <th align="center">Navn</th>
                    <th align="center">Hold</th>
                    <th align="center">Organisation</th>
                    {this.state.campaignActivities.map((activity) => {
                      if (activity.choices?.length) {
                        return activity.choices.map((cho) => (
                          <th
                            key={activity.id + cho.text_da + "qname"}
                            align="center"
                          >
                            {activity.activityName + " - " + cho.text_da}
                          </th>
                        ));
                      } else {
                        return (
                          <th key={activity.id + "name"} align="center">
                            {activity.activityName}
                          </th>
                        );
                      }
                    })}
                    <th>Samlet</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.users.map((user) => {
                    return (
                      <tr key={user.id}>
                        <td align="center">{user.id}</td>
                        <td align="center">{user.userName}</td>
                        <td align="center">
                          {user.team
                            ? this.state.teams.find(
                                (team) => team.id == user.team
                              )?.teamName
                            : "N/A"}
                        </td>
                        <td align="center">
                          {user.company
                            ? this.state.companies.find(
                                (company) => company.id == user.company
                              ).companyName
                            : "N/A"}
                        </td>
                        {this.state.campaignActivities.map((activity) => {
                          if (activity.choices?.length) {
                            return activity.choices.map((cho) => (
                              <td key={activity.id} align="center">
                                {
                                  user.stats.activities[
                                    activity.id + cho.text_da
                                  ]
                                }
                              </td>
                            ));
                          } else {
                            return (
                              <td key={"ck_" + activity.id} align="center">
                                {user.stats.activities[activity.id]}
                              </td>
                            );
                          }
                        })}
                        <td key={"ckt_" + user.id} align="center">
                          {this.state.totalCounts[user.id]}
                        </td>
                      </tr>
                    );
                  })}
                  <tr key="total">
                    <td align="center">Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    {this.state.campaignActivities.map((activity) => {
                      if (activity.choices?.length) {
                        return activity.choices.map((cho) => (
                          <td
                            key={activity.id + cho.text_da + "total"}
                            align="center"
                          >
                            {this.state.totalCounts[activity.id + cho.text_da]}
                          </td>
                        ));
                      } else {
                        return (
                          <td align="center">
                            {this.state.totalCounts[activity.id]}
                          </td>
                        );
                      }
                    })}
                    <td align="center">
                      {this.state.totalCounts.totalActivityCount}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {!this.state.loading &&
              this.state.mode === "quiz" &&
              this.renderQuizStats()}
          </div>
        </section>
      </>
    );
  }
}
